import { useAppSelector } from '../../../Hooks/useAppSelector'
import { ContainerSelectors } from '../StoreAdapter'

export const useContainersSelector = () => {
  return useAppSelector(ContainerSelectors.selectEntities)
}
